import axios from 'axios';
import Config from '../config';
import { AppRoutes, TeamsRoutes, WebRoutes } from '../components/routes/route.path';
import { ChannelUserService } from './ChannelUserService';
import { app, authentication } from '@microsoft/teams-js';
import store from '../stores/app-store';
import { AppState } from '../reducers/models';



const ChannelLogin = (userName: string, password: string, stayLoggedIn: boolean, navigate) => {
    var data = new URLSearchParams();
    data.append("username", userName);
    data.append("password", password);
    data.append("grant_type", "password");
    data.append("keep_me_signed_in", stayLoggedIn ? "True" : "False");

    var conf = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
    return axios.post(`${Config.FALKON_CONNECT_API}/api/v1/user/connect/token`, data, conf).then(async (res) => {
        var dt = new Date();
        dt.setSeconds(dt.getSeconds() + res.data.expires_in);
        res.data.expires_in = dt;
        localStorage.setItem("user-token", JSON.stringify(res.data));
        // localStorage.setItem("channeluser-token", JSON.stringify(res.data))


        let token = res.data.access_token;
        const [, payloadBase64] = token.split('.');
        const payloadString = atob(payloadBase64);
        const payload = JSON.parse(payloadString);

        // ChannelUserService.getCurrentUser(payload.UserId).then((res) => {
        //     navigate(AppRoutes.CHANNELS_DASHBOARD)
        // }).catch((err) => {

        // })

        getCurrentUser(payload.UserId, navigate);

    }).catch((err) => {
        throw err;
    })
}

const getCurrentUser = async (id, navigate) => {
    await ChannelUserService.getCurrentUser(id).then((res) => {
        const ReduxState: AppState = store.getState();
        ChannelUserService.getCurrentUserFromLocalStorage().RoleID == 1 ? navigate(AppRoutes.CHANNELS_ORGANISATIONS) :
            (ReduxState.IsWordPress || ReduxState.Shopify) ? navigate(AppRoutes.CHANNELS) : navigate(AppRoutes.CHANNELS_DASHBOARD)
    }).catch((err) => {

    })
}

const getToken = () => {
    var token = localStorage.getItem("user-token");
    // var token = localStorage.getItem("channeluser-token");
    return !!token ? JSON.parse(localStorage.getItem("user-token").toString()!) : {};
};

const isUserLoggedIn = () => {
    let isRedirect = window.location.href.includes("/redirect")
    return !!getToken() && (isRedirect ? true : !!JSON.parse(localStorage.getItem("current-user")))
}

const logout = () => {
    localStorage.removeItem("user-token")
    localStorage.removeItem("current-user")
    localStorage.removeItem("Timezone")
    localStorage.removeItem("IsLiveChat")
    window.location.replace(AppRoutes.CHANNELS_SIGN_IN);
};

const verifyEmailToken = (token) => {
    if (token) {
        return axios.post(`${Config.FALKON_CONNECT_API}/api/v1/user/verify/email`, { token })
    }
}

const verifyInvitationToken = (token) => {
    if (token) {
        return axios.post(`${Config.FALKON_CONNECT_API}/api/v1/user/verify/invite`, { token })
    }
}

const resetpassword = (data) => {
    return axios.post(`${Config.FALKON_CONNECT_API}/api/v1/user/signup/invite`, data)
}

const forgetpassword = (email) => {
    return axios.post(`${Config.FALKON_CONNECT_API}/api/v1/user/forgot/password`, { email })
}

const googleSignIn = (auth_code: string, navigate) => {
    return axios.post(`${Config.FALKON_CONNECT_API}/api/v1/user/google/signup`, { auth_code }).then((res) => {
        var dt = new Date();
        dt.setSeconds(dt.getSeconds() + res.data.expires_in);
        res.data.expires_in = dt;
        localStorage.setItem("user-token", JSON.stringify(res.data));
        // localStorage.setItem("channeluser-token", JSON.stringify(res.data))


        let token = res.data.access_token;
        const [, payloadBase64] = token.split('.');
        const payloadString = atob(payloadBase64);
        const payload = JSON.parse(payloadString);
        getCurrentUser(payload.UserId, navigate)
    }).catch((err) => {
        throw err
    })
}

const microsoftSignIn = (auth_code: string, navigate) => {
    return axios.post(`${Config.FALKON_CONNECT_API}/api/v1/user/microsoft/signup`, { auth_code }).then((res) => {
        var dt = new Date();
        dt.setSeconds(dt.getSeconds() + res.data.expires_in);
        res.data.expires_in = dt;
        localStorage.setItem("user-token", JSON.stringify(res.data));
        // localStorage.setItem("channeluser-token", JSON.stringify(res.data))


        let token = res.data.access_token;
        const [, payloadBase64] = token.split('.');
        const payloadString = atob(payloadBase64);
        const payload = JSON.parse(payloadString);
        getCurrentUser(payload.UserId, navigate)
    }).catch((err) => {
        throw err
    })
}

const getGoogleUrl = (openInTeams: boolean, navigate?: any) => {
    if (openInTeams) {
        app.initialize()
        authentication.authenticate({
            url: TeamsRoutes.TEAMS_POPUP_CONTAINER.replace(":type", "google"),
            width: 1000,
            height: 600,
            successCallback: (result) => {
                ChannelAuthService.googleSignIn(result, navigate)
                    .then((res) => {
                    })
                    .catch((err) => {
                        console.log("error", err)
                        navigate(AppRoutes.CHANNELS_USER_NOT_FOUND.replace(":deletedBy", err.response.data.userStatus.admin_role !== 1 ? "org" : "sys"))
                    })
            },
            failureCallback: (reason) => {
                console.error('Authentication failed:', reason);
            }
        });
    }
    else {
        const rootUrl = `https://accounts.google.com/o/oauth2/v2/auth`;
        const options = {
            redirect_uri: Config.FALKON_CONNECT_APP_URL + WebRoutes.CHANNELS_LOGIN_REDIRECT.replace(":login", "google"),
            client_id: Config.FALKON_CONNECT_LOGIN_GOOGLE_CLIENT_ID,
            access_type: 'offline',
            response_type: 'code',
            prompt: 'consent',
            scope: [
                'https://www.googleapis.com/auth/userinfo.profile',
                'https://www.googleapis.com/auth/userinfo.email',
            ].join(' '),
        };
        const qs = new URLSearchParams(options).toString();
        const authUrl = `${rootUrl}?${qs}`;
        window.top.location.href = authUrl;
    }
};

const getMicrosoftUrl = (openInTeams: boolean, navigate?: any) => {
    if (openInTeams) {
        app.initialize()
        authentication.authenticate({
            url: TeamsRoutes.TEAMS_POPUP_CONTAINER.replace(":type", "microsoft"),
            width: 1000,
            height: 600,
            successCallback: (result) => {
                ChannelAuthService.microsoftSignIn(result, navigate).then((res) => {
                }).catch((err) => {
                    console.log("error", err)
                    navigate(AppRoutes.CHANNELS_USER_NOT_FOUND.replace(":deletedBy", err.response.data.userStatus.admin_role !== 1 ? "org" : "sys"))
                })
            },
            failureCallback: (reason) => {
                console.error('Authentication failed:', reason);
            }
        });
    } else {
        const rootUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize`;
        // window.location.origin + WebRoutes.CHANNELS_LOGIN_REDIRECT.replace(":login", "microsoft")
        const options = {
            redirect_uri: window.location.origin + WebRoutes.CHANNELS_LOGIN_REDIRECT.replace(":login", "microsoft"),
            client_id: Config.FALKON_CONNECT_LOGIN_MICROSOFT_CLIENT_ID,
            response_type: 'code',
            prompt: 'consent',
            scope: 'User.Read',
        };

        const qs = new URLSearchParams(options).toString();
        const authUrl = `${rootUrl}?${qs}`;

        window.location.href = authUrl;
    }
};

const getLivechatToken = () => {
    var token = localStorage.getItem("livechat-token");
    return !!token ? JSON.parse(localStorage.getItem("livechat-token").toString()!) : {};
}

export const ChannelAuthService = {
    ChannelLogin,
    getToken,
    isUserLoggedIn,
    logout,
    verifyEmailToken,
    verifyInvitationToken,
    resetpassword,
    forgetpassword,
    googleSignIn,
    microsoftSignIn,
    getGoogleUrl,
    getMicrosoftUrl,
    getLivechatToken
}
